var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3571 0H2.6346C1.18103 0 0 1.23413 0 2.74913V35.3812C0 36.8962 1.18103 38.1303 2.6346 38.1303H34.3571C35.8107 38.1303 37 36.8962 37 35.3812V2.74913C37 1.23413 35.8107 0 34.3571 0ZM11.1826 32.6832H5.69866V14.4861H11.1908V32.6832H11.1826ZM8.44062 12.0008C6.68147 12.0008 5.26094 10.5284 5.26094 8.72402C5.26094 6.91964 6.68147 5.44719 8.44062 5.44719C10.1915 5.44719 11.6203 6.91964 11.6203 8.72402C11.6203 10.5369 10.1998 12.0008 8.44062 12.0008V12.0008ZM31.7391 32.6832H26.2551V23.8315C26.2551 21.7207 26.2138 19.0056 23.4058 19.0056C20.5482 19.0056 20.1105 21.3036 20.1105 23.6783V32.6832H14.6266V14.4861H19.8875V16.9714H19.9618C20.6969 15.5415 22.4891 14.035 25.1567 14.035C30.7067 14.035 31.7391 17.8055 31.7391 22.708V32.6832V32.6832Z",
    fill: "#D7AA26",
    fillOpacity: 0.86
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLinkedin);
export default __webpack_public_path__ + "static/media/yellow-linkedin.e1668087053e732fd64e92d80d57e8ad.svg";
export { ForwardRef as ReactComponent };